import { StatusVariants } from '@genie-fintech/ui/style/element'

export const APP_ENV_STATE_DATA: Record<number, StatusVariants['kind']> = {
  1: 'secondary',
  2: 'primary',
  3: 'tertiary',
  4: 'warning',
  5: 'danger'
}
